import React, { Component } from 'react'
import isEqual from 'react-fast-compare'

import { BookingTableCell } from 'components/Bookings/components'
import { currencyMaker } from 'services/helpers'

export class BookingTableCellsBase extends Component {
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps)
  }

  createCellData = () => {
    const { booking, fromCityTypeByLabel } = this.props

    const currency = currencyMaker(fromCityTypeByLabel)

    const { from, to, surname, name, phone, price, paidStatus, discount, note, source, sourceId, place = '' } = booking

    return [
      { label: 'from', value: from, source },
      { label: 'to', value: to, source },
      { label: 'surname', value: surname },
      { label: 'name', value: name },
      { label: 'phone', value: phone },
      { label: 'price', value: price, paidStatus, currency, discount, sourceId, source },
      { label: 'note', value: note },
      { label: 'place', value: place }
    ]
  }

  renderCell = data => {
    const { booking: { id }, mainCities, isEditing } = this.props

    return (
      <BookingTableCell
        id={id}
        key={data.label}
        data={data}
        isEditing={isEditing}
        mainCities={mainCities}
      />
    )
  }

  render() {
    return this.createCellData().map(this.renderCell)
  }
}



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingTableCells/BookingTableCells.js